import React from "react";
import Video from "../../components/video/Video";

const Dashboard = () => {
  return <Video />;
};

export default Dashboard;
